import { useNavigate } from 'react-router-dom';
import { Container, PageHeader } from '@vnetwork/ui/layout';
import { Card, CardHeader, CardTitle, CardDescription, CardBody, Button } from '@vnetwork/ui/primitives';
import { useCurrentEmployee } from '@/api/account';
import { formatDate, seniorityFrom } from '@/lib/format';
import { AccountNavCards } from './components/AccountNavCards';
import { AccountIdentityHeader } from './components/AccountIdentityHeader';
import { InfoGrid } from './components/InfoGrid';
import { WorkdayTab } from './components/tabs/WorkdayTab';

/** Identity header + key facts for the current employee (shared header + facts grid). */
function IdentityCard() {
  const { data: emp } = useCurrentEmployee();
  return (
    <AccountIdentityHeader>
      {emp ? (
        <InfoGrid
          minColWidth={150}
          items={[
            { label: 'Department', value: emp.department_name },
            { label: 'Onboard', value: formatDate(emp.employee_start_date) },
            { label: 'Seniority', value: seniorityFrom(emp.employee_start_date) },
            { label: 'Day-off left', value: emp.employee_day_off_left },
          ]}
        />
      ) : null}
    </AccountIdentityHeader>
  );
}

/**
 * Account landing — identity summary + quick-navigation cards to each account
 * sub-page (info / vcards / workdays / day-offs / businesses / on-call /
 * incomes / regulations). Every area is its own route/page (no in-page tabs).
 */
export default function AccountHome() {
  const navigate = useNavigate();
  return (
    <Container size="full">
      <PageHeader title="My Account" description="Your workspace account and personal records" />
      <div style={{ display: 'grid', gap: 'var(--vn-space-4)' }}>
        <IdentityCard />

        {/* Quick current-month attendance — full page at /account/workdays. */}
        <Card flat>
          <CardHeader
            actions={<Button size="sm" variant="ghost" onClick={() => navigate('/account/workdays')}>Open</Button>}
          >
            <CardTitle>Workday — this month</CardTitle>
            <CardDescription>Attendance and workday records</CardDescription>
          </CardHeader>
          <CardBody>
            <WorkdayTab />
          </CardBody>
        </Card>

        <AccountNavCards />
      </div>
    </Container>
  );
}
